import { IApiKey } from '../../types';

// API Keys Action Types
export enum ApiKeysActionTypes {
  // Generate API key actions
  GENERATE_API_KEY_REQUEST = 'GENERATE_API_KEY_REQUEST',
  GENERATE_API_KEY_SUCCESS = 'GENERATE_API_KEY_SUCCESS',
  GENERATE_API_KEY_FAILURE = 'GENERATE_API_KEY_FAILURE',

  // Get API key actions
  GET_API_KEY_REQUEST = 'GET_API_KEY_REQUEST',
  GET_API_KEY_SUCCESS = 'GET_API_KEY_SUCCESS',
  GET_API_KEY_FAILURE = 'GET_API_KEY_FAILURE',

  // Clear actions
  CLEAR_API_KEYS_STATE = 'CLEAR_API_KEYS_STATE',
}

// API Keys Action Interfaces
export interface GenerateApiKeyRequestAction {
  type: ApiKeysActionTypes.GENERATE_API_KEY_REQUEST;
  [key: string]: any;
}

export interface GenerateApiKeySuccessAction {
  type: ApiKeysActionTypes.GENERATE_API_KEY_SUCCESS;
  payload: string;
  [key: string]: any;
}

export interface GenerateApiKeyFailureAction {
  type: ApiKeysActionTypes.GENERATE_API_KEY_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetApiKeyRequestAction {
  type: ApiKeysActionTypes.GET_API_KEY_REQUEST;
  [key: string]: any;
}

export interface GetApiKeySuccessAction {
  type: ApiKeysActionTypes.GET_API_KEY_SUCCESS;
  payload: IApiKey;
  [key: string]: any;
}

export interface GetApiKeyFailureAction {
  type: ApiKeysActionTypes.GET_API_KEY_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearApiKeysStateAction {
  type: ApiKeysActionTypes.CLEAR_API_KEYS_STATE;
  [key: string]: any;
}

// Union type for all API Keys actions
export type ApiKeysAction =
  | GenerateApiKeyRequestAction
  | GenerateApiKeySuccessAction
  | GenerateApiKeyFailureAction
  | GetApiKeyRequestAction
  | GetApiKeySuccessAction
  | GetApiKeyFailureAction
  | ClearApiKeysStateAction;

// API Keys State Interface
export interface ApiKeysState {
  // Data
  apiKey: IApiKey | null;
  generatedKey: string | null;

  // Loading states
  loading: boolean;
  generateLoading: boolean;
  fetchLoading: boolean;

  // Error states
  error: string | null;
  generateError: string | null;
  fetchError: string | null;

  // Success states
  success: string | null;
  generateSuccess: boolean;
  fetchSuccess: boolean;
}
